module.exports = __webpack_public_path__ + "static/img/editIcon.d5422321.png";